import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-end;
  padding: 10px;
`

export const SearchBox = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`

export const CancelLabel = styled.span`
  color: ${({ theme }) => `${theme.colors.headerText}`};
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
`
